module.exports = {
      id: "strategy-usage",
      viewBox: "0 0 13.247 22.012",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#strategy",
      toString: function () {
        return this.url;
      }
    }